<div class="row mb-4 mt-3">
  <div class="col-md-12 d-flex flex-row align-items-center">
    <h4 class="mb-0">
      <div (click)="voltar()" style="cursor: pointer;padding: 2px 20px 0 0;float: left;">
        <i class="fas fa-arrow-left"></i>
      </div>
      Configurações da eleição <strong>{{eleicaoParametrizacao.titulo}}</strong>
    </h4>
    <div class="badger"> {{eleicaoParametrizacao.statusEleicao.replace('_', ' ')}}
    </div>
  </div>
</div>
<!-- -->
<div class="row">
  <div class="col-md-12">
    <nav>
      <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
        <a class="nav-item nav-link active" id="nav-profile-tab" data-toggle="tab" href="#nav-candidatos" role="tab"
          aria-controls="nav-profile">Candidatos / Respostas</a>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div class="tab-pane fade show active pt-4" id="nav-candidatos" role="tabpanel">
        <cadastro-candidato-assistente></cadastro-candidato-assistente>
      </div>
    </div>
  </div>
</div>